/*
  sk-facets.js — filtro com aplicação automática (sem botão "Aplicar").

  Usado por main-collection-product-grid.liquid e main-search.liquid. Antes cada
  seção tinha o seu próprio script inline: a coleção ganhou AJAX e o "Ver
  resultados" que aplica de verdade, a busca ficou com a versão antiga (o botão
  do rodapé só fechava a gaveta e descartava o filtro). Unificar é o que impede
  a próxima divergência.

  Regras:
  - mexeu num filtro -> aplica sozinho (debounce), troca a grade via Section
    Rendering API, atualiza contagem e URL. Sem reload, sem "Aplicar".
  - o botão do rodapé da gaveta NÃO aplica: quando o cliente chega nele o filtro
    já está aplicado, ele só fecha ("Ver 137 jogos").
  - fechar no X / no fundo não desfaz nada (padrão de mercado); quem desfaz é o
    "Limpar filtros".
  - qualquer falha de rede cai no submit normal do form (reload) — o filtro
    nunca fica preso.
*/
(function () {
  if (window.__skFacetsInit) return;
  window.__skFacetsInit = true;

  var DEBOUNCE_MS = 350;

  /* Params que sobrevivem ao rebuild da URL. Tudo que não é filtro nem está
     aqui é descartado (ex.: o `sk_price_band` dos botões de faixa de preço,
     que é só controle de UI e não pode vazar pra URL). */
  var PASSTHROUGH = ['q', 'options[prefix]', 'type', 'sort_by', 'preview_theme_id'];

  var SECTION_ID = null;
  var lastTrigger = null;
  var seq = 0;
  var debounceTimer = null;
  var cache = {};

  function resolveSectionId() {
    var el = document.querySelector(
      '#main-collection-filters[data-id], #main-search-filters[data-id], #product-grid[data-id]'
    );
    return el ? el.getAttribute('data-id') : null;
  }

  /* ---------- gaveta (mobile/tablet) ---------- */

  function getDrawer() { return document.getElementById('SteamDrawer'); }

  /* ---------- trava de rolagem do fundo ----------
     Pôr `overflow: hidden` no elemento raiz NÃO segura a página. Medido em
     06/08/2026 com a gaveta aberta: a página andou de 700px para 1.100px sob o
     dedo — e isso no Chromium; no Safari do iPhone é ainda mais confiável que
     falhe. Sintoma para o cliente: rola dentro do filtro, a lista atrás anda
     junto, fecha e está em outro ponto da coleção.

     O que segura em todo navegador é fixar o BODY na posição atual. O `top`
     negativo preserva o ponto de leitura enquanto ele está fixo, e o `scrollTo`
     na volta devolve o cliente exatamente onde estava — sem isso ele cairia no
     topo da página ao fechar a gaveta. */
  var scrollTravado = 0;
  var fundoTravado = false;

  function travarFundo() {
    if (fundoTravado) return;
    scrollTravado = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body.style;
    b.position = 'fixed';
    b.top = -scrollTravado + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    fundoTravado = true;
  }

  function destravarFundo() {
    if (!fundoTravado) return;
    var b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.right = '';
    b.width = '';
    fundoTravado = false;
    /* Com o body fixo o documento encolhe para a altura da janela. Se o
       `scrollTo` rodar antes do navegador refazer o layout, 700px é truncado
       para 0 e o cliente cai no topo — foi o que aconteceu no primeiro teste.
       Ler `offsetHeight` força o recálculo na hora, antes de rolar. */
    void document.body.offsetHeight;
    window.scrollTo(0, scrollTravado);
  }

  function openDrawer(trigger) {
    var d = getDrawer();
    if (!d) return;
    lastTrigger = trigger || null;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    travarFundo();
    var close = d.querySelector('.steam-drawer-close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    destravarFundo();
    /* `focus()` sem preventScroll ROLA a página até o elemento. Como o gatilho
       "Filtrar" fica no topo da lista, ele desfazia na hora a posição que o
       destravarFundo() acabou de restaurar — o cliente fechava o filtro e caía
       no começo da coleção. Mesmo cuidado que o sk-back-to-top já toma. */
    if (lastTrigger) { lastTrigger.focus({ preventScroll: true }); lastTrigger = null; }
  }

  /* ---------- URL / fetch ---------- */

  function keepParam(name) {
    return name.indexOf('filter.') === 0 || PASSTHROUGH.indexOf(name) !== -1;
  }

  function buildParams(form) {
    var out = new URLSearchParams();
    var cur = new URLSearchParams(location.search);
    PASSTHROUGH.forEach(function (k) { if (cur.has(k)) out.set(k, cur.get(k)); });
    if (form) {
      new FormData(form).forEach(function (v, k) {
        if (v === '' || v == null || !keepParam(k)) return;
        if (PASSTHROUGH.indexOf(k) !== -1) out.set(k, v);
        else out.append(k, v);
      });
    }
    return out;
  }

  /* `path` só é passado pela troca de categoria: o filtro de tag do Shopify
     mora no caminho (/collections/all/rpg), não em query param. */
  function prettyURL(params, path) {
    var p = new URLSearchParams(params);
    p.delete('section_id');
    var s = p.toString();
    return (path || location.pathname) + (s ? '?' + s : '');
  }

  function fetchDoc(params, path) {
    var fp = new URLSearchParams(params);
    fp.set('section_id', SECTION_ID);
    var target = path || location.pathname;
    var key = target + '?' + fp.toString();
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(key, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        cache[key] = doc;
        return doc;
      });
  }

  /* ---------- troca de conteúdo ---------- */

  function readCount(doc) {
    var el = doc.querySelector('.sidebar-results-count');
    if (!el) return null;
    var m = el.textContent.replace(/\./g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function updateCounts(n) {
    if (n == null) return;
    var noun = n === 1 ? 'jogo' : 'jogos';
    document.querySelectorAll('[data-sk-result-count]').forEach(function (s) { s.textContent = n; });
    document.querySelectorAll('[data-sk-result-noun]').forEach(function (s) { s.textContent = noun; });
    document.querySelectorAll('.sidebar-results-count').forEach(function (el) {
      el.textContent = 'Mostrando ' + n + ' ' + noun;
    });
  }

  function swapGrid(doc) {
    var incoming = doc.querySelector('#ProductGridContainer');
    var current = document.querySelector('#ProductGridContainer');
    if (!incoming || !current) return;
    current.innerHTML = incoming.innerHTML;
    /* O container NÃO é trocado (só o miolo), então a classe que o Liquid
       escreveu na primeira pintura ficaria congelada. Espelhar a do documento
       novo mantém uma fonte só da verdade — quem decide se o selo de desconto
       aparece continua sendo o servidor. */
    current.classList.toggle('sk-sem-selo', incoming.classList.contains('sk-sem-selo'));
  }

  /* O mesmo snippet de filtros é renderizado duas vezes (sidebar do desktop e
     gaveta). Espelha o estado do form usado nos outros, senão trocar de
     viewport mostra caixas desmarcadas com a grade já filtrada. */
  function syncForms(source) {
    if (!source) return;
    document.querySelectorAll('form.filter-form').forEach(function (form) {
      if (form === source) return;
      source.querySelectorAll('input[name], select[name]').forEach(function (el) {
        var twin;
        if (el.type === 'checkbox' || el.type === 'radio') {
          twin = form.querySelector('[name="' + el.name + '"][value="' + el.value + '"]');
          if (twin) twin.checked = el.checked;
        } else {
          twin = form.querySelector('[name="' + el.name + '"]');
          if (twin) twin.value = el.value;
        }
      });
    });
  }

  function setBusy(on) {
    var grid = document.querySelector('#ProductGridContainer');
    if (!grid) return;
    grid.classList.toggle('sk-loading', !!on);
    if (on) grid.setAttribute('aria-busy', 'true');
    else grid.removeAttribute('aria-busy');
  }

  /* ---------- aplicar ---------- */

  /* ---------- correção do filtro de preço ----------
     O `filter.v.price` do Shopify casa no nível da VARIANTE: pede "até R$ 20"
     e ele devolve todo produto que tenha ALGUMA variante até R$ 20. Como 35 dos
     203 jogos de PlayStation têm a variante "Aluguel 15 dias" por R$ 19,90, a
     coleção respondia com jogos de R$ 99,90 — verificado em 06/08/2026 em
     /collections/playstation?filter.v.price.lte=20.

     Não há como consertar isso no app: é assim que a filtragem por variante
     funciona. Aqui a resposta do servidor é tratada como CONJUNTO CANDIDATO e o
     tema descarta quem está fora da faixa pelo preço de COMPRA — que é
     justamente o que o card exibe desde que ele passou a ignorar o aluguel.

     Efeito colateral aceito: a paginação continua sendo do servidor, então uma
     página pode mostrar menos de 12 cards. O contador é recalculado para o que
     sobrou, para o número nunca contradizer o que está na tela. */
  function precoDoCard(card) {
    var el = card.querySelector('.price-item--sale, .price__regular .price-item, .price-item');
    if (!el) return null;
    var t = el.textContent.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    var v = parseFloat(t);
    return isNaN(v) ? null : v;
  }

  function corrigirPreco(form) {
    if (!form) return null;
    var campoMin = form.querySelector('[name$="price.gte"]');
    var campoMax = form.querySelector('[name$="price.lte"]');
    var min = campoMin && campoMin.value !== '' ? parseFloat(campoMin.value) : null;
    var max = campoMax && campoMax.value !== '' ? parseFloat(campoMax.value) : null;
    if (min === null && max === null) return null;

    var fora = 0, dentro = 0;
    document.querySelectorAll('#ProductGridContainer .card-wrapper').forEach(function (card) {
      var preco = precoDoCard(card);
      if (preco === null) { dentro++; return; }
      if ((min !== null && preco < min) || (max !== null && preco > max)) {
        var vaga = card.closest('li') || card;
        vaga.remove();
        fora++;
      } else {
        dentro++;
      }
    });
    return fora > 0 ? dentro : null;
  }

  function applyForm(form, closeAfter, path) {
    if (!SECTION_ID) {
      if (path) { location.href = prettyURL(buildParams(form), path); return; }
      if (form) form.submit();
      return;
    }
    var params = buildParams(form);

    /* Grade oculta = estamos no ESTADO HUB dos hubs de plataforma, onde a
       curadoria manda e a grade só aparece quando há filtro. Trocar a grade por
       fetch aqui não adianta: quem decide o estado é o CSS da seção do hub, que
       foi renderizado no carregamento e não vem no fetch. Uma navegação de
       verdade faz o servidor montar a página já no estado resultado.
       Custa um carregamento, e só na primeira vez que o cliente filtra. */
    var gradeAtual = document.querySelector('#ProductGridContainer');
    if (gradeAtual && gradeAtual.offsetParent === null) {
      location.href = prettyURL(params, path);
      return;
    }

    setBusy(true);
    var my = ++seq;
    fetchDoc(params, path).then(function (doc) {
      if (my !== seq) return;
      swapGrid(doc);
      var sobraram = corrigirPreco(form);
      updateCounts(sobraram !== null ? sobraram : readCount(doc));
      syncForms(form);
      /* As alças não têm `name`, então syncForms não as alcança: reposiciona
         pelos campos (que ele acabou de espelhar) nos dois formulários. */
      refreshSliders();
      try { history.pushState({}, '', prettyURL(params, path)); } catch (e) { /* no-op */ }
      setBusy(false);
      if (closeAfter) closeDrawer();
    }).catch(function () {
      if (path) { location.href = prettyURL(params, path); return; }
      if (form) form.submit();
      else location.href = prettyURL(params);
    });
  }

  function applySort(value) {
    var params = new URLSearchParams(location.search);
    params.set('sort_by', value);
    params.delete('section_id');
    if (!SECTION_ID) { location.href = prettyURL(params); return; }
    setBusy(true);
    var my = ++seq;
    fetchDoc(params).then(function (doc) {
      if (my !== seq) return;
      swapGrid(doc);
      updateCounts(readCount(doc));
      try { history.pushState({}, '', prettyURL(params)); } catch (e) { /* no-op */ }
      setBusy(false);
    }).catch(function () { location.href = prettyURL(params); });
  }

  /* ---------- filtros por tag (plataforma × categoria) ---------- */

  /* As duas dimensões dividem a MESMA URL: na coleção viram segmentos do
     caminho (/collections/all/steam+rpg, onde `+` é "E"), na busca viram
     cláusulas do `q`. Por isso o destino é REMONTADO a partir da seleção viva
     das duas, em vez de lido do href: depois da primeira troca por AJAX o
     snippet de filtros não é re-renderizado, então o href do "RPG" ainda
     apontaria pra plataforma anterior e escolher gênero desfaria a plataforma.
     Os hrefs continuam certos no carregamento — são o caminho de quem está
     sem JS. */
  var DIMS = ['plat', 'cat'];

  /* CATEGORIA É MULTI (Q-223). Plataforma continua sendo uma só: são duas
     opções que particionam o catálogo, marcar as duas seria o mesmo que não
     filtrar. Categoria são 13 e cada jogo tem exatamente uma — marcar duas só
     faz sentido como SOMA (OU), e cruzar devolveria zero sempre. */
  function multiplo(dim) { return dim === 'cat'; }

  /* Lê a seleção de UMA cópia só. O snippet de filtros é renderizado duas
     vezes na mesma página (sidebar do desktop + gaveta do celular): varrer o
     documento inteiro contaria cada categoria marcada duas vezes e a consulta
     sairia com o gênero repetido. */
  function selectionOf(dim) {
    var box = document.querySelector('.sk-cats[data-sk-dim="' + dim + '"]');
    var tags = [], handles = [];
    if (box) {
      box.querySelectorAll('.sk-cat.is-on').forEach(function (el) {
        var t = el.getAttribute('data-sk-tag') || '';
        if (!t) return;                      /* "Todas" não é seleção */
        tags.push(t);
        handles.push(el.getAttribute('data-sk-handle') || '');
      });
    }
    return { tags: tags, handles: handles };
  }

  /* Consulta canônica da busca: <termo> AND product_type:<plat> AND (tag:"A" OR tag:"B").
     A plataforma sai como product_type e não como tag porque é assim que as
     coleções /collections/steam e /collections/playstation são definidas —
     medido em 18/08/2026, 5 jogos ativos têm o tipo sem ter a tag. */
  function montarQ(base, plat, cats) {
    var q = base || '*';
    if (plat) q += ' AND product_type:' + plat;
    if (cats.length) {
      q += ' AND (' + cats.map(function (t) { return 'tag:"' + t + '"'; }).join(' OR ') + ')';
    }
    return q;
  }

  function urlDaBusca(form, plat, cats) {
    var rota = (form && form.getAttribute('data-sk-search-url')) || '/search';
    return rota + '?q=' + encodeURIComponent(montarQ('', plat, cats)) +
      '&options%5Bprefix%5D=last&type=product';
  }

  /* O contador do cabeçalho do grupo não é re-renderizado depois do AJAX — sem
     isso ele congela no número com que a página nasceu. */
  function atualizarContador(dim, n) {
    document.querySelectorAll('[data-sk-count-grupo="' + dim + '"]').forEach(function (el) {
      el.hidden = n === 0;
      var alvo = el.querySelector('[data-sk-count-n]');
      if (alvo) alvo.textContent = String(n);
    });
  }

  function applyTag(pill) {
    var dim = pill.getAttribute('data-sk-dim');
    var tag = pill.getAttribute('data-sk-tag') || '';
    var handle = pill.getAttribute('data-sk-handle') || '';
    var coll = pill.getAttribute('data-sk-coll');

    var sel = {};
    DIMS.forEach(function (d) { sel[d] = selectionOf(d); });

    /* "Todas" (tag vazia) limpa a dimensão; nas múltiplas o clique ALTERNA —
       inclusive na pílula que TROCA DE COLEÇÃO.
       Até 02/09/2026 a categoria era escolha ÚNICA dentro de uma coleção de
       gênero (Q-193): ali "RPG" era ir para a coleção de RPG, não somar. O
       efeito colateral é que, estando numa categoria, não havia como acrescentar
       uma segunda — e é exatamente de dentro de uma categoria que o cliente pede
       a soma. Agora alterna também aqui, e a segunda categoria migra para a
       busca pela mesma regra da Q-223: o `+` do caminho é "E" e devolveria zero
       (426 dos 460 jogos ativos têm exatamente um gênero, medido em 02/09/2026;
       as 34 exceções são todas Coop/Multiplayer).
       Plataforma continua sendo uma só. */
    if (!tag) {
      sel[dim] = { tags: [], handles: [] };
    } else if (multiplo(dim)) {
      var i = sel[dim].tags.indexOf(tag);
      if (i === -1) { sel[dim].tags.push(tag); sel[dim].handles.push(handle); }
      else { sel[dim].tags.splice(i, 1); sel[dim].handles.splice(i, 1); }
    } else {
      sel[dim] = { tags: [tag], handles: [handle] };
    }

    /* O X do chip fica FORA do formulário (ele vive na barra de chips). Sem
       cair no form aqui, sair da categoria levava os outros filtros embora —
       quem clica no X da categoria não pediu pra perder o preço. */
    var form = pill.closest('form.filter-form') || document.querySelector('form.filter-form');
    var naBusca = !!(form && form.hasAttribute('data-sk-base-q'));
    var cats = sel.cat.tags;

    /* TROCA DE PLATAFORMA DENTRO DE UM HUB (07/08/2026).
       Em /collections/steam e /collections/playstation a plataforma não é tag
       no caminho — é a própria coleção. A pílula carrega o destino em
       data-sk-coll e aqui vira NAVEGAÇÃO DE VERDADE, não troca de grade:
         1. as duas coleções usam TEMPLATES diferentes (collection.pc.json e
            collection.playstation.json), então o `section_id` desta página não
            existe na outra e o fetch voltaria vazio;
         2. muda a página inteira (hero, chips, trilhos), não só a grade.
       O gênero escolhido vai junto; a faixa de preço NÃO — as pontas do slider
       são calculadas por coleção, e carregar um teto de PC para o PlayStation
       mostraria resultado filtrado com um slider que não bate. */
    if (coll) {
      var segs = [];
      if (dim === 'cat') {
        /* TROCA DE CATEGORIA DENTRO DE UMA COLEÇÃO DE GÊNERO (Q-193).
           Espelho do caso acima: aqui a coleção de destino já É o gênero, e
           quem viaja como segmento do caminho é a PLATAFORMA escolhida
           (/collections/rpg-1/steam). O `handle` só vem preenchido no gênero
           sem coleção própria, e aí ele é que vira segmento sobre
           /collections/all. Ordem plataforma -> categoria, a mesma do ramo de
           tag: a mesma seleção tem que gerar sempre a mesma URL. */
        /* SOMA DE GÊNEROS A PARTIR DA COLEÇÃO (02/09/2026). Espelho exato da
           migração da Q-223 mais abaixo: com duas categorias o destino não é
           coleção nenhuma — a união dos dois gêneros só existe na busca. A
           plataforma efetiva vai junto (no hub ela é a coleção, não é tag). */
        if (cats.length > 1) {
          var sk_plat_eff = (form && form.getAttribute('data-sk-plat-eff')) || sel.plat.tags[0] || '';
          location.href = urlDaBusca(form, sk_plat_eff, cats);
          return;
        }
        if (sel.plat.handles[0]) segs.push(sel.plat.handles[0]);
        if (handle) segs.push(handle);
      } else {
        /* Com duas categorias nem a coleção de destino dá conta (o caminho é
           "E"): o destino passa a ser a busca, com a plataforma nova. */
        if (cats.length > 1) { location.href = urlDaBusca(form, tag, cats); return; }
        if (sel.cat.handles[0]) segs.push(sel.cat.handles[0]);
      }
      var destino = coll + (segs.length ? '/' + segs.join('+') : '');
      var ordem = new URLSearchParams(location.search).get('sort_by');
      if (ordem) destino += '?sort_by=' + encodeURIComponent(ordem);
      location.href = destino;
      return;
    }

    var path = null;

    if (naBusca) {
      var base = form.getAttribute('data-sk-base-q') || '';
      var q = montarQ(base, sel.plat.tags[0] || '', cats);
      /* O `q` novo entra nos formulários ANTES de montar os params: é de lá
         que sai a consulta do próximo filtro, senão mexer no preço depois
         voltaria pra busca sem as tags. */
      document.querySelectorAll('form.filter-form [name="q"]').forEach(function (i) { i.value = q; });
    } else if (cats.length > 1) {
      /* MIGRAÇÃO COLEÇÃO -> BUSCA (Q-223). O caminho da coleção só sabe "E"
         (/collections/all/rpg+soulslike = 0 jogos, medido em 18/08/2026), e a
         união dos dois gêneros só existe na busca. A tradução é fiel: as
         coleções de plataforma são regra de product_type, e é ele que vai na
         consulta. Navegação de verdade, não AJAX — a busca é outro template e
         o section_id desta página não existe lá. */
      var platEff = (form && form.getAttribute('data-sk-plat-eff')) || sel.plat.tags[0] || '';
      location.href = urlDaBusca(form, platEff, cats);
      return;
    } else {
      /* Ordem fixa plataforma -> categoria: a mesma seleção tem que gerar
         sempre a mesma URL, que é chave do cache e entrada no histórico. */
      var segs = [];
      DIMS.forEach(function (d) { if (sel[d].handles[0]) segs.push(sel[d].handles[0]); });
      var basePath = (form && form.getAttribute('data-sk-base-path')) || location.pathname;
      path = basePath + (segs.length ? '/' + segs.join('+') : '');
    }

    /* Acende só dentro da dimensão clicada — a outra fica como está. E em
       TODAS as cópias do filtro (sidebar e gaveta), não só na que foi clicada. */
    document.querySelectorAll('.sk-cats[data-sk-dim="' + dim + '"] .sk-cat').forEach(function (a) {
      var t = a.getAttribute('data-sk-tag') || '';
      a.classList.toggle('is-on', t ? sel[dim].tags.indexOf(t) !== -1 : sel[dim].tags.length === 0);
      if (a.hasAttribute('aria-pressed')) a.setAttribute('aria-pressed', a.classList.contains('is-on') ? 'true' : 'false');
    });
    atualizarContador(dim, sel[dim].tags.length);

    applyForm(form, false, path);
  }

  /* ---------- eventos ---------- */

  function init() {
    SECTION_ID = resolveSectionId();
    /* Com JS vivo o "Aplicar" não tem função: some. Sem JS ele continua sendo
       a única forma de aplicar (o form é um GET normal), por isso ele nasce
       visível no HTML e quem o esconde é esta linha, não o CSS. */
    document.querySelectorAll('[data-sk-apply-fallback]').forEach(function (b) { b.hidden = true; });
    refreshSliders();

    /* A correção de preço também precisa rodar em CARREGAMENTO, não só depois
       do fetch. Quem chega por link direto, recarrega, ou é mandado para cá pela
       navegação de verdade que o estado hub dispara, recebe a resposta CRUA do
       servidor — que sobre-inclui por casar no nível da variante. Sem esta
       chamada, filtrar a partir do hub devolvia jogos de R$ 119,90 num teto de
       R$ 60 (medido em 06/08/2026). */
    if (location.search.indexOf('filter.v.price') !== -1) {
      var sobraram = corrigirPreco(document.querySelector('form.filter-form'));
      if (sobraram !== null) updateCounts(sobraram);
    }

    var d = getDrawer();
    if (d && !d.classList.contains('is-open')) d.setAttribute('aria-hidden', 'true');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sk-steam-drawer-open]');
    if (open) { openDrawer(open); return; }
    if (e.target.closest('[data-sk-steam-drawer-close]')) { closeDrawer(); return; }

    /* Plataforma e categoria: links de verdade (funcionam sem JS), mas aqui
       viram troca de grade sem reload, preservando preço e ordenação. */
    var pill = e.target.closest('[data-sk-tag-link]');
    if (pill) {
      e.preventDefault();
      applyTag(pill);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- faixa de preço (slider de duas alças) ---------- */

  function priceParts(box) {
    return {
      handles: box.querySelectorAll('.range-input'),
      min: box.querySelector('.min-input'),
      max: box.querySelector('.max-input'),
      bar: box.querySelector('.slider-range'),
      ceiling: parseFloat(box.getAttribute('data-max')) || 0,
      /* O piso deixou de ser sempre 0 em 06/08/2026: as pontas do slider
         passaram a ser a faixa real de compra da coleção. Toda conta de
         porcentagem e todo clamp precisam partir daqui. */
      floor: parseFloat(box.getAttribute('data-min')) || 0
    };
  }

  /* Pinta a barra roxa entre as duas alças. */
  function paintSlider(box) {
    var p = priceParts(box);
    if (!p.handles.length || !p.bar || !p.ceiling) return;
    var lo = parseFloat(p.handles[0].value);
    var hi = parseFloat(p.handles[1].value);
    var faixa = p.ceiling - p.floor;
    if (faixa <= 0) return;
    p.bar.style.left = ((lo - p.floor) / faixa) * 100 + '%';
    p.bar.style.width = ((hi - lo) / faixa) * 100 + '%';
    /* Nos últimos 5% as duas alças se sobrepõem e a de baixo fica inalcançável */
    p.handles[0].style.zIndex = lo > p.floor + faixa * 0.95 ? 3 : 2;
  }

  /* Arrastou -> escreve nos campos, que são quem de fato vira filtro.
     Alça no extremo = limite em branco: sem gte=0&lte=max pendurado na URL. */
  function sliderToInputs(box) {
    var p = priceParts(box);
    if (!p.handles.length) return;
    var lo = parseFloat(p.handles[0].value);
    var hi = parseFloat(p.handles[1].value);
    if (hi < lo) { var t = lo; lo = hi; hi = t; p.handles[0].value = lo; p.handles[1].value = hi; }
    if (p.min) p.min.value = lo <= p.floor ? '' : lo;
    if (p.max) p.max.value = hi >= p.ceiling ? '' : hi;
    paintSlider(box);
  }

  /* Digitou nos campos -> reposiciona as alças. */
  function inputsToSlider(box, edited) {
    var p = priceParts(box);

    /* Faixa invertida devolve zero jogo e parece que o filtro quebrou. Quem
       digita "até 25" com um mínimo de 30 pendurado quer 25 como teto, então o
       outro lado sai de cena em vez de brigar. */
    if (p.min && p.max && p.min.value !== '' && p.max.value !== '') {
      var a = parseFloat(p.min.value);
      var b = parseFloat(p.max.value);
      if (!isNaN(a) && !isNaN(b) && b < a) {
        if (edited === p.max) p.min.value = '';
        else p.max.value = '';
      }
    }
    if (!p.handles.length) return;
    var lo = p.min && p.min.value !== '' ? parseFloat(p.min.value) : p.floor;
    var hi = p.max && p.max.value !== '' ? parseFloat(p.max.value) : p.ceiling;
    p.handles[0].value = Math.max(p.floor, Math.min(lo, p.ceiling));
    p.handles[1].value = Math.max(p.floor, Math.min(hi, p.ceiling));
    paintSlider(box);
  }

  function refreshSliders() {
    document.querySelectorAll('.filter-price').forEach(function (box) {
      inputsToSlider(box, null);
    });
  }

  /* Durante o arraste só a UI acompanha — o filtro sai no `change`, que o
     navegador dispara quando a alça é solta. Um request por ajuste. */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('.range-input')) return;
    var box = e.target.closest('.filter-price');
    if (box) sliderToInputs(box);
  });

  /* Marcou/desmarcou um filtro (ou saiu de um campo de preço) -> aplica. */
  document.addEventListener('change', function (e) {
    var sortSelect = e.target.closest('[data-sk-sort-redirect]');
    if (sortSelect) { applySort(sortSelect.value); return; }

    var form = e.target.closest('form.filter-form');
    if (!form) return;

    var box = e.target.closest('.filter-price');
    if (box) {
      if (e.target.matches('.range-input')) sliderToInputs(box);
      else if (e.target.matches('.input-number')) inputsToSlider(box, e.target);
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { applyForm(form, false); }, DEBOUNCE_MS);
  });

  /* Enter num campo de preço, ou o "Aplicar" de quem está sem JS por um
     instante: nunca deixa recarregar a página à toa. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.filter-form');
    if (!form) return;
    e.preventDefault();
    clearTimeout(debounceTimer);
    applyForm(form, false);
  });

  window.addEventListener('popstate', function () { location.reload(); });
})();
